import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-tacho-summary-data',
  templateUrl: './tacho-summary-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./tacho-summary-data.component.scss'],
})
export class TachoSummaryDataComponent implements OnInit {

  @Input() public slotData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
